import React from "react";

const ChatIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8941 15.8916C13.3473 18.4386 9.57611 18.9889 6.48998 17.5617C6.03439 17.3783 5.66087 17.23 5.30578 17.23C4.31671 17.2359 3.08561 18.1949 2.44577 17.5558C1.80593 16.9159 2.76569 15.6838 2.76569 14.6888C2.76569 14.3337 2.62332 13.9668 2.43991 13.5103C1.01199 10.4247 1.56306 6.65224 4.10985 4.10601C7.36097 0.853695 12.643 0.853695 15.8941 4.10517C19.1511 7.36251 19.1452 12.6401 15.8941 15.8916Z"
        stroke={color ? color : "white"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.284 10.3442H13.2915"
        stroke={color ? color : "white"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.94417 10.3442H9.95167"
        stroke={color ? color : "white"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.60432 10.3442H6.61182"
        stroke={color ? color : "white"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ChatIcon;
